import store from "../store";

export default class HttpInterceptor {
    responseErrorHandler(error) {
        switch (error?.response?.status) {
            case 401:
                store.state.user = {}

                store.getters.getConfig.then(() => {
                    setTimeout(() => {
                        if (store.state.config.general['environment'] !== 'local') {
                            document.location.href = `${store.state.config.general['omni-portal-base-url']}/login?referrer=${btoa(document.location.href)}`
                        }
                    }, 3000)
                })

                break
        }

        return Promise.reject(error)
    }

}
